export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9729.6d1a668a.jpg";